import axios from 'axios';
import { API } from './apiConfig';

const authHeader = () => ({ withCredentials: true });

const appendFiles = (formData, files = []) => {
  files.forEach(file => formData.append('attachments', file, file.name));
};

export const submitTicket = async ({ subject, category, message, screenshot, userId, attachments = [] }) => {
  if (screenshot || attachments.length) {
    const formData = new FormData();
    formData.append('subject', subject);
    formData.append('category', category);
    formData.append('message', message);
    if (userId) formData.append('user_id', userId);
    if (screenshot) formData.append('screenshot', screenshot, 'screenshot.png');
    appendFiles(formData, attachments);
    const { data } = await axios.post(`${API}/support-tickets`, formData, {
      headers: { ...authHeader().headers, 'Content-Type': 'multipart/form-data' }
    });
    return data;
  } else {
    const { data } = await axios.post(
      `${API}/support-tickets`,
      { subject, category, message, ...(userId ? { user_id: userId } : {}) },
      authHeader()
    );
    return data;
  }
};

export const fetchTickets = async () => {
  const { data } = await axios.get(`${API}/support-tickets`, authHeader());
  return data;
};

export const getTicket = async id => {
  const { data } = await axios.get(`${API}/support-tickets/${id}`, authHeader());
  return data;
};

export const replyToTicket = async (id, message, internal = false, attachments = []) => {
  let data;
  if (attachments.length) {
    const formData = new FormData();
    formData.append('message', message);
    formData.append('internal', internal ? '1' : '0');
    appendFiles(formData, attachments);
    ({ data } = await axios.post(`${API}/support-tickets/${id}/messages`, formData, {
      headers: { ...authHeader().headers, 'Content-Type': 'multipart/form-data' }
    }));
  } else {
    ({ data } = await axios.post(
      `${API}/support-tickets/${id}/messages`,
      { message, internal },
      authHeader()
    ));
  }
  return data;
};

export const updateTicket = async (id, payload) => {
  const { data } = await axios.patch(
    `${API}/support-tickets/${id}`,
    payload,
    authHeader()
  );
  return data;
};

export const editTicketMessage = async (ticketId, messageId, message) => {
  const { data } = await axios.put(
    `${API}/support-tickets/${ticketId}/messages/${messageId}`,
    { message },
    authHeader()
  );
  return data;
};

export const fetchMyTickets = async () => {
  const { data } = await axios.get(`${API}/support-tickets/mine`, authHeader());
  return data;
};

export const getTicketScreenshot = async id => {
  const res = await axios.get(`${API}/support-tickets/${id}/screenshot`, {
    ...authHeader(),
    responseType: 'blob'
  });
  return res.data;
};

export const getTicketAttachmentUrl = (ticketId, attachmentId) => (
  `${API}/support-tickets/${ticketId}/attachments/${attachmentId}`
);

export const getTicketAttachment = async (ticketId, attachmentId) => {
  const res = await axios.get(getTicketAttachmentUrl(ticketId, attachmentId), {
    ...authHeader(),
    responseType: 'blob'
  });
  return res.data;
};

export const fetchSupportCategories = async () => {
  const { data } = await axios.get(`${API}/support-categories`, authHeader());
  return data;
};

export const createSupportCategory = async name => {
  const { data } = await axios.post(
    `${API}/admin/support-categories`,
    { name },
    authHeader()
  );
  return data;
};

export const updateSupportCategory = async (id, name) => {
  const { data } = await axios.put(
    `${API}/admin/support-categories/${id}`,
    { name },
    authHeader()
  );
  return data;
};

export const deleteSupportCategory = async id => {
  const { data } = await axios.delete(
    `${API}/admin/support-categories/${id}`,
    authHeader()
  );
  return data;
};

export const fetchSupportStatuses = async () => {
  const { data } = await axios.get(`${API}/support-statuses`, authHeader());
  return data;
};

export const createSupportStatus = async name => {
  const { data } = await axios.post(
    `${API}/admin/support-statuses`,
    { name },
    authHeader()
  );
  return data;
};

export const updateSupportStatus = async (id, name) => {
  const { data } = await axios.put(
    `${API}/admin/support-statuses/${id}`,
    { name },
    authHeader()
  );
  return data;
};

export const deleteSupportStatus = async id => {
  const { data } = await axios.delete(
    `${API}/admin/support-statuses/${id}`,
    authHeader()
  );
  return data;
};
